/*
 * Public API Surface of pepperi-lib/images-filmstrip
 */
export * from './images-filmstrip.module';
export * from './images-filmstrip.component';
